import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';
import { LEGACY_ROUTE_ALIASES, MENU_REGISTRY, MenuItem } from '../constants/menu-registry';

const MAX_ITEMS = 5;

@Injectable({ providedIn: 'root' })
export class QuickAccessService {
  private readonly _items$ = new BehaviorSubject<MenuItem[]>([]);
  readonly items$ = this._items$.asObservable();

  constructor(private api: ApiService, private auth: AuthService) {}

  /** Called once by QuickAccessBarComponent on init, after the session is established. */
  loadFromSession(): void {
    const routes: string[] = this.auth.getCurrentUser()?.quickAccessRoutes || [];
    this._items$.next(
      routes
        .map(r => LEGACY_ROUTE_ALIASES[r] || r)
        .map(r => MENU_REGISTRY.find(m => m.route === r))
        .filter((m): m is MenuItem => !!m)
    );
  }

  get items(): MenuItem[] { return this._items$.getValue(); }

  isPinned(route: string): boolean { return this.items.some(i => i.route === route); }

  canPin(): boolean { return this.items.length < MAX_ITEMS; }

  pin(route: string): void {
    if (this.isPinned(route) || !this.canPin()) return;
    const item = MENU_REGISTRY.find(m => m.route === route);
    if (!item) return;
    this._persist([...this.items, item]);
  }

  unpin(route: string): void {
    this._persist(this.items.filter(i => i.route !== route));
  }

  clear(): void {
    this._items$.next([]);
  }

  private _persist(items: MenuItem[]): void {
    this._items$.next(items);
    const routes = items.map(i => i.route);
    const user = this.auth.getCurrentUser();
    this.auth.updateStoredQuickAccessRoutes(routes);
    if (user?.userID) {
      this.api.updateQuickAccess(user.userID, routes).subscribe({ error: () => {} });
    }
  }
}
